import * as React from "react";
import * as BS from "react-bootstrap";
import * as Comp from "../../../../components";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";

interface OwnProps {
    api: Api;
    eventId: number;
}

interface OwnState {
    abstractId?: number;
    abstractType?: M.Abstract.AbstractTypeEdit;
    body?: string;
    show: boolean;
}

export class PreviewModal extends Comp.Base.BaseComponent<OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);

        this.state = {
            show: false,
        };
    }

    public componentDidMount() {
        this._isMounted = true;
    }

    public componentWillUnmount() {
        this._isMounted = false;
    }

    public async close() {
        await this.clearStateAsync();
        await this.setStateAsync({
            ...this.state,
            abstractId: undefined,
            abstractType: undefined,
            show: false,
        });
    }

    public show(abstractType: M.Abstract.AbstractTypeEdit, abstractId: number | undefined) {
        this.setState({
            ...this.state,
            abstractId,
            abstractType,
            body: undefined,
            show: true,
        }, () => {
            this.loadPreview();
        });
    }

    public render() {
        const type = this.state.abstractType;

        const modalProps: BS.ModalProps = {
            backdrop: true,
            bsStyle: "lg",
            keyboard: true,
            onEscapeKeyDown: () => this.close(),
            onHide: () => {},
            show: this.state.show,
        } as any; // needed "as any" here because "onEscapeKeyDown" does not exist in the latest typed definitions of react-bootstrap

        const body = this.state.body && !this.state.loading
            ? <Comp.Page.EmailBody><div dangerouslySetInnerHTML={{ __html: this.state.body }} /></Comp.Page.EmailBody>
            : <h3 style={{ margin: "0 auto", textAlign: "center" }}><Comp.Generic.LoadingIcon /> Loading&hellip;</h3>;

        return <BS.Modal { ...modalProps }>
            <BS.Modal.Header
                bsClass="modal-header alert-info"
                closeButton
                onHide={() => this.close()}
            >
                <BS.Modal.Title>
                    Email preview for {type ? type.shortName : "..."}
                </BS.Modal.Title>
            </BS.Modal.Header>

            <BS.Modal.Body style={{ minHeight: "200px", position: "relative" }}>
                {this.getErrorAlert()}

                {body}
            </BS.Modal.Body>

            <BS.Modal.Footer>
                <BS.Button bsStyle="primary" onClick={() => this.close()}>Close</BS.Button>
            </BS.Modal.Footer>
        </BS.Modal>;
    }

    private async loadPreview() {
        if (!this.state.abstractType)
            return;

        await this.toggleLoadingAsync(true);

        const abstractId = this.state.abstractId;
        const eventId = this.props.eventId;
        const typeId = this.state.abstractType.id;
        const qp = { queryParams: { abstractId }};
        const result = await this.props.api.get(Api.endpoints.admin.abstract.invitationEmailPreview.withUrlParams({ eventId, typeId }), qp);

        if (!this._isMounted)
            return;

        await this.toggleLoadingAsync(false);

        if (result.isSuccess && result.data) {
            await this.setStateAsync({ ...this.state, body: result.data });
        }
        else {
            this.setErrors(M.Result.Result.errorsOrMessage(result));
        }
    }
}



// WEBPACK FOOTER //
// ./src/containers/adminAbstracts/invitationEmails/components/PreviewModal.tsx